module.exports = __webpack_public_path__ + "static/media/skyscout-monocular-2.73372cb3.jpg";